import { c as _c } from "react/compiler-runtime";
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { useOnWalletChange } from './useOnWalletChange';

/**
 * Closes the open review dialog the moment the connected wallet changes — a different account
 * address or a network switch inside the wallet — after the dialog was opened.
 *
 * Every flow's review dialog (Vault V1 / Vault V2 / market actions v2) holds a transaction built
 * for one specific signer, chain, and on-chain position. Once the wallet switches, that bundle is
 * stale: `validateClientParams` would reject it at submit with an account/chain-mismatch toast,
 * stranding the user on a review for the previous wallet. Closing returns them to the panel so the
 * next action is built against the new wallet's position.
 *
 * Mount this inside the review dialog only — it deliberately does NOT cover the processing dialog
 * (`ConfirmDialogV2`, opened `{ closable: false }`), where a transaction may already be in flight.
 */
const useCloseDialogOnWalletChange = () => {
  const $ = _c(2);
  const {
    toggleDialog
  } = useDialogContext();
  let t0;
  if ($[0] !== toggleDialog) {
    t0 = () => toggleDialog(false);
    $[0] = toggleDialog;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useOnWalletChange(t0);
};
export default useCloseDialogOnWalletChange;